import React, { Component } from 'react';
import ModalMaterial from '../../../../materials/ModalMaterial';
import SpinMaterial from '../../../../materials/SpinMaterial';
import FormAdminComponent from './FormAdminComponent';
import { FormAdminType } from './FormAdminComponent';

interface IProps {
  visible: any;
  jenisToggle: any;

  isLoading: any;
  isView?: boolean;
  handleChange: (name: string, value: any) => void;
  handleClear: () => void;
  initialData: FormAdminType;
  handleSubmit?: () => void;
}

export default class AddAdminComponent extends Component<IProps> {
  render() {
    return (
      <div>
        <ModalMaterial
          className={''}
          width={'80%'}
          style={{}}
          teksTitle={'TAMBAHKAN ADMIN'}
          visible={
            this.props.jenisToggle === 'AddAdmin' && this.props.visible === true
              ? true
              : false
          }
          onCancel={this.props.handleClear}
          content={
            <SpinMaterial
              spinning={this.props.isLoading}
              style={{}}
              size={'large'}
              content={<FormAdminComponent {...this.props} />}
            />
          }
        />
      </div>
    );
  }
}
